import {observer} from 'mobx-react';

const IndexTableRow = observer(({title, description, icon, showPath, showRoute}) => {
  // empty implementation because we're using <Table> to render IndexTable
  return null;
});

export default IndexTableRow;
